import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

export interface PageMeta {
  page: number;
  per_page: number;
  total: number;
  total_pages: number;
}

interface Props {
  meta: PageMeta | null;
  onPageChange: (page: number) => void;
  /** Optional label for the item type (default: "items"). */
  itemLabel?: string;
}

export function Pagination({ meta, onPageChange, itemLabel = 'items' }: Props) {
  if (!meta || meta.total === 0) return null;
  const { page, per_page, total, total_pages } = meta;
  const first = (page - 1) * per_page + 1;
  const last = Math.min(page * per_page, total);
  if (total_pages <= 1) {
    return (
      <div className="flex items-center justify-between text-xs text-muted-foreground py-2">
        <span>{total} {itemLabel}</span>
      </div>
    );
  }
  return (
    <div className="flex items-center justify-between text-xs text-muted-foreground py-2 gap-3 flex-wrap">
      <span>
        Showing <span className="tabular-nums">{first}–{last}</span> of <span className="tabular-nums">{total}</span> {itemLabel}
      </span>
      <div className="flex items-center gap-1">
        <Button variant="outline" size="sm" className="h-7 px-2" onClick={() => onPageChange(page - 1)} disabled={page <= 1}>
          <ChevronLeft className="h-3.5 w-3.5" />
        </Button>
        <span className="px-2 tabular-nums">{page} / {total_pages}</span>
        <Button variant="outline" size="sm" className="h-7 px-2" onClick={() => onPageChange(page + 1)} disabled={page >= total_pages}>
          <ChevronRight className="h-3.5 w-3.5" />
        </Button>
      </div>
    </div>
  );
}
